import { OptionItemDto } from '@/types';
import { request } from '@/utils/ajax';

export interface OptionItemCreateParams {
    profileProductId?: number;
    projectProductId?: number;
    price: number;
    isDefault: boolean;
    isArchived: boolean;
    sortOrder: number;
}
export interface OptionItemUpdateParams {
    price: number;
}

export function getOptionItemsByGroup(optionGroupId: number): Promise<OptionItemDto[]> {
    return request(`api/option-group/${optionGroupId}/items`).then((x) => x.json());
}

export function archiveOptionItem(optionItemId: number): Promise<any> {
    return request(`api/option-item/${optionItemId}/archive`, { method: 'put' });
}

export function unarchiveOptionItem(optionItemId: number): Promise<any> {
    return request(`api/option-item/${optionItemId}/unarchive`, { method: 'put' });
}

export function setOptionItemAsDefault(optionItemId: number): Promise<any> {
    return request(`api/option-item/${optionItemId}/default`, { method: 'put' });
}
export function updateOptionItem(optionItemId: number, option: OptionItemUpdateParams): Promise<any> {
    return request(`api/option-item/${optionItemId}`, { method: 'put', body: option, json: true });
}

export function updateOptionItems(optionGroupId: number, options: OptionItemCreateParams[]): Promise<any> {
    return request(`api/option-group/${optionGroupId}/items`, { method: 'put', body: options, json: true });
}

export function reorderOptionItems(optionGroupId: number, orderedItemIds: number[]): Promise<any> {
    return request(`api/option-group/${optionGroupId}/options/reorder`, { method: 'put', body: orderedItemIds, json: true });
}

export function setOptionItemConfiguratorMapping(optionItemId: number, configuratorMappingId: string | null): Promise<any> {
    return request(`api/option-item/${optionItemId}/configurator-mapping`, { method: 'put', body: { configuratorMappingId }, json: true });
}
